export interface TaxSlab {
	/** Display label, e.g. "Up to ₹4L" */
	label: string;
	/** Display rate, e.g. "5%" or "Nil" */
	rate: string;
	/** Upper-bound value to send to the API, e.g. 800000 for "₹4L to ₹8L".
	 *  "Above X" slabs use 30,00,000 as the representative value. */
	value: number;
}

export const NEW_REGIME_SLABS: TaxSlab[] = [
	{ label: "Up to ₹4L", rate: "Nil", value: 400000 },
	{ label: "₹4L to ₹8L", rate: "5%", value: 800000 },
	{ label: "₹8L to ₹12L", rate: "10%", value: 1200000 },
	{ label: "₹12L to ₹16L", rate: "15%", value: 1600000 },
	{ label: "₹16L to ₹20L", rate: "20%", value: 2000000 },
	{ label: "₹20L to ₹24L", rate: "25%", value: 2400000 },
	{ label: "Above ₹24L", rate: "30%", value: 3000000 },
];

export const OLD_REGIME_SLABS: TaxSlab[] = [
	{ label: "Up to ₹2.5L", rate: "Nil", value: 250000 },
	{ label: "₹2.5L to ₹5L", rate: "5%", value: 500000 },
	{ label: "₹5L to ₹10L", rate: "20%", value: 1000000 },
	{ label: "Above ₹10L", rate: "30%", value: 3000000 },
];

export const getSlabsByRegime = (regime: "new" | "old"): TaxSlab[] =>
	regime === "new" ? NEW_REGIME_SLABS : OLD_REGIME_SLABS;

/** Returns options formatted for the Select component */
export const getSlabSelectOptions = (regime: "new" | "old") =>
	getSlabsByRegime(regime).map((slab) => ({
		label: `${slab.label} - ${slab.rate}`,
		value: slab.value.toString(),
	}));

/** Finds the best matching slab for a stored salary.
 *  Tries exact match first, then finds the slab the salary falls into. */
export const findSlabByValue = (
	salary: number,
	regime: "new" | "old",
): TaxSlab | undefined => {
	const slabs = getSlabsByRegime(regime);
	const n = Number(salary);
	return (
		slabs.find((s) => s.value === n) ??
		slabs.find((s) => s.value >= n) ??
		slabs[slabs.length - 1]
	);
};
